import { IsBoolean, IsOptional } from 'class-validator';

export class CollectionVisibilityUpdateModel {
  @IsOptional()
  @IsBoolean()
  public visible?: boolean;
}
